import { render, staticRenderFns } from "./px-panel.vue?vue&type=template&id=0644e4dc&scoped=true&"
import script from "./px-panel.vue?vue&type=script&lang=ts&"
export * from "./px-panel.vue?vue&type=script&lang=ts&"
import style0 from "./px-panel.vue?vue&type=style&index=0&id=0644e4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644e4dc",
  null
  
)

export default component.exports